import { isBlankAiPage } from '@repo/lib';

export const STARTER_PROMPTS = {
  checkout: [
    {
      label: 'A 12-week fitness coaching program, $600 or 3 monthly payments',
      prompt:
        'A 12-week online fitness coaching program called Strong in 12, for $600 or 3 monthly payments of $210. It includes a personal training plan, a weekly video check-in with your coach and a private group chat. Add a photo of a gym and keep the tone motivating and direct.',
    },
    {
      label: 'A yoga studio membership at $60 a month or $600 a year',
      prompt:
        'A membership for Still Point Yoga at $60 a month, or $600 a year, which works out to two months free. Members get unlimited classes, free mat hire and 10% off weekend workshops. Add a photo of a yoga class with a calm, earthy look.',
    },
    {
      label: 'Donations for our church roof fund, pay what you want',
      prompt:
        'Donations for the Grace Community Church roof fund, pay what you want from $10 with $50 suggested. Explain that we are raising $40,000 to repair the roof before winter, and thank people for every gift, large or small. Add a photo of a church and keep the tone warm and hopeful.',
    },
  ],
  event: [
    {
      label: 'A pottery workshop this Saturday, 20 seats at $45',
      prompt:
        'A 2-hour beginner pottery workshop at Hearth Clay Studio, 42 Mill Street, Asheville, this Saturday from 10am to 12pm. One ticket type, Standard, at $45 with 20 seats. Clay, glazes, aprons and firing are included, and pieces are ready to collect two weeks later. Ask for a phone number, and add a photo of hands shaping clay with a warm, relaxed tone.',
    },
    {
      label: 'A kids soccer camp with early bird and standard tickets',
      prompt:
        "A 3-day soccer camp for kids aged 7 to 12 at Riverside Park, Monday to Wednesday next week, 9am to 3pm each day. Two ticket types: Early bird at $120 with 30 available, and Standard at $150. Ask for the child's name, age, any medical needs and an emergency contact phone number. Add a photo of a soccer field and give it a bold, sporty look.",
    },
    {
      label: 'A free community iftar dinner that asks about dietary needs',
      prompt:
        'A free community iftar at Al-Noor Masjid, 210 Oak Avenue, next Saturday from 7pm, with dinner served at sunset. Two free ticket types: Adult with 120 places and Child (under 12) with 60 places. Ask about dietary needs and allergies, and say everyone is welcome, whatever their faith. Add a photo of a shared meal and keep the tone warm and welcoming.',
    },
  ],
  form: [
    {
      label: 'A volunteer sign-up for our food bank, with availability and skills',
      prompt:
        'A volunteer sign-up for Eastside Community Food Bank. Ask for name, email, phone, when they can help (weekday mornings, weekday evenings or Saturdays) and their skills, such as driving, sorting donations or cooking. Add a photo of volunteers and keep the tone friendly and grateful.',
    },
    {
      label: 'A new member form for our tennis club that asks for playing level',
      prompt:
        'A new member application for Parkside Tennis Club. Ask for name, email, phone, date of birth, playing level (beginner, intermediate, advanced or competitive) and what they want to join: coaching, social play or league matches. Add a photo of a tennis court with a clean, sporty look.',
    },
    {
      label: 'A client intake form for my design studio about budget and timeline',
      prompt:
        'A client intake form for Northline Design Studio. Ask for name, email, company, the type of project (branding, website or print), budget (under $5,000, $5,000 to $15,000, or over $15,000), ideal launch date and a short description of the project. Add a photo of a design desk with a calm, neutral look.',
    },
  ],
};

export function isBlankEditorPage(page) {
  if (!Object.hasOwn(STARTER_PROMPTS, page?.type)) return false;
  const title = page.type === 'checkout' ? page.product?.title : page.title;
  return isBlankAiPage(page.type, title);
}
